import { StoreState } from "../../../store/store.interface";
import { searchParam } from "../../search-v2/store/search-v2.selectors";
import { IElasticAnalyticsAPI } from "../apis/elastic-cloud-analytics.api";

export interface IElasticAnalyticsService {
    postClickthroughAnalytics(documentId: string, state: StoreState);
}

export class ElasticAnalyticsService implements IElasticAnalyticsService {
    private elasticAnalyticsApi: IElasticAnalyticsAPI;

    constructor(elasticAnalyticsApi: IElasticAnalyticsAPI) {
        this.elasticAnalyticsApi = elasticAnalyticsApi;
    }
    
    async postClickthroughAnalytics(documentId: string, state: StoreState) {
        try {
            const terms = searchParam(state);
            await this.elasticAnalyticsApi.postElasticAnalyticsClickthrough({document_id: documentId, searchTerms: terms ?? ""});
        } catch (error) {
            console.error(`Failed to post the analytics data to Elastic ${(error as Error).message}`);
        }
    }
}